import { TippspielState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '@/store/state';
import { ITippspielLeaderboardEntry, ITippspielMatch, ITippspielTipp } from '../types';


export const mutations = {
  setMatches(state: TippspielState, payload: ITippspielMatch[]) {
    state.matches = payload;
  },
  setLeaderboard(state: TippspielState, payload: ITippspielLeaderboardEntry[]) {
    state.leaderboard = payload;
  },
  setMyTipp(state: TippspielState, payload: ITippspielTipp) {
    const match = state.matches.find(m => m.id === payload.match_id);
    if (match) {
      match.my_tipp = payload;
    }
  },
};

const {commit} = getStoreAccessors<TippspielState | any, State>('');

export const commitSetMatches = commit(mutations.setMatches);
export const commitSetLeaderboard = commit(mutations.setLeaderboard);
export const commitSetMyTipp = commit(mutations.setMyTipp);
